<template>
    <div class="nav-bar">
        <div class="nav-out-wrapper">
            <div class="nav-title">
                <router-link :to="{name: '/'}"><img :src="`${IMG_HOST}a-plus-logo.png?v=3.0`"></router-link>
                <div class="nav-wrapper">
                    <router-link @mouseout.native="tempCurrent = currentPage" @mouseover.native="setTempCurrent(0)" :class="{'current': tempCurrent === 0}" :to="{name: '/'}">首页</router-link>
                    <router-link @mouseout.native="tempCurrent = currentPage" @mouseover.native="setTempCurrent(1)" :class="{'current': tempCurrent === 1}" :to="{name: 'copyrighterIndex'}">我有作品</router-link>
                    <a href="/personalcenter/todo" v-if="$store.state.user.isOperator" @mouseout="tempCurrent = currentPage" @mouseover="setTempCurrent(3)" :class="{'current': tempCurrent === 3}">我是运营</a>
                    <router-link v-else @mouseout.native="tempCurrent = currentPage" @mouseover.native="setTempCurrent(2)" :class="{'current': tempCurrent === 2}" :to="{name: 'anchorIndex'}">我有好声音</router-link>
                </div>
            </div>
            <!-- 登录显示 -->
            <el-popover popper-class="pop-user" v-if="$store.state.user.name" ref="userpop" placement="bottom" trigger="hover">
                <div class="pop-zone">
                    <a class="pop-item" @click="toCopyrightCenter">版权方工作台</a>
                    <a v-if="$store.state.user.isOperator" class="pop-item" :href="`${$store.state.A_PC_HOST}/personalcenter/todo`">运营工作台</a>
                    <a v-else class="pop-item" @click="toAnchorCenter">主播工作台</a>
                    <a class="pop-item" @click="logout">退出登录</a>
                </div>
                <div slot="reference" class="nav-tail">
                    <img v-if="$store.state.user.logoPic" :src="`${$store.state.UPLOAD_IMG_HOST}${$store.state.user.logoPic}`">
                    <span>{{$store.state.user.name}}</span>
                    <i style="color: white;" class="el-icon-caret-bottom el-icon--right"></i>
                </div>
            </el-popover>
            <!-- 未登录显示 -->
            <div v-else class="nav-tail nav-tail-off">
                <a :href="$store.state.LOGIN_URL+'?fromUri='+$store.state.HOST">登录</a>
                <span> |</span>
                <a :href="$store.state.REGISTER_URL">注册</a>
            </div>
        </div>
        <div v-if="currentPage === 1" class="sub-nav-wrapper">
            <div class="sub-nav">
                <a @mouseout.native="tempSubCurrent = currentSubPage" @mouseover.native="setTempSubCurrent(1)"
                   :class="{'sub-current': tempSubCurrent === 1}" @click="toCopyrightCenter">版权方工作台</a>
                <router-link @mouseout.native="tempSubCurrent = currentSubPage" @mouseover.native="setTempSubCurrent(2)"
                             :class="{'sub-current': tempSubCurrent === 2}"
                             :to="{name: 'copyrighterHelpCenter'}">帮助中心</router-link>
            </div>
        </div>
        <div v-if="currentPage === 2" class="sub-nav-wrapper">
            <div class="sub-nav">
                <router-link @mouseout.native="tempSubCurrent = currentSubPage" @mouseover.native="setTempSubCurrent(3)"
                   :class="{'sub-current': tempSubCurrent === 3}" v-if="isAnchor"
                             :to="{name: 'anchorCenter'}">主播工作台</router-link>
                <span v-else>主播工作台</span>
                <a @mouseout="tempSubCurrent = currentSubPage" @mouseover="setTempSubCurrent(4)"
                   :class="{'sub-current': tempSubCurrent === 4}"
                   :href="`${$store.state.A_PC_HOST}/requirementview`">海选任务</a>
                <router-link @mouseout.native="tempSubCurrent = currentSubPage" @mouseover.native="setTempSubCurrent(5)"
                             :class="{'sub-current': tempSubCurrent === 5}" :to="{name: 'anchorHelpCenter'}">帮助中心</router-link>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    export default {
        components: {

        },
        data() {
            return {
                currentPage: 0,
                tempCurrent: 0,
                currentSubPage: -1,
                tempSubCurrent: -1,
                defaultImg: this.$store.state.DEFAULT_PORTRAIT_100
            }
        },
        methods: {
          toCopyrightCenter () {
            if (this.$store.state.user.author.authorProgressStatus !== 9) {
              this.$notify.warning({
                title: this.$i18n.t('word.tips'),
                message: '您还未成功认证为版权方，请先入驻'
              });
            } else {
              this.$router.push({name: 'worksManagement'});
            }
          },
          toAnchorCenter () {
            if (this.$store.state.user.anchor.level < 0) {
              this.$notify.warning({
                title: this.$i18n.t('word.tips'),
                message: '您还不是主播，请先进行认证'
              });
            } else {
              this.$router.push({name: 'anchorMyAudioBook'});
            }
          },
          setCurrentPage() {
            const name = this.$route.matched[0].name;
            if(name === 'copyrighterIndex' || name === 'copyrighter' || name === 'copyrighterHelpCenter' || name === 'uploadCopyright') {
              this.currentPage = this.tempCurrent = 1;
            } else if (name === 'anchorIndex' || name === 'anchorHelpCenter' || name === 'anchorCenter' || name === 'fastMissionIntro'){
              this.currentPage = this.tempCurrent = 2;
            } else {
              this.currentPage = this.tempCurrent = 0;
            }
          },
          setTempCurrent(temp) {
            this.tempCurrent = temp;
          },
          setCurrentSubPage() {
            const name = this.$route.matched[0].name;
            if(name === 'anchorHelpCenter') {
              this.currentSubPage = this.tempSubCurrent = 5;
            } else if (name === 'copyrighter' && this.$route.name === 'worksManagement') {
              this.currentSubPage = this.tempSubCurrent = 1;
            } else if (name === 'anchorCenter') {
              this.currentSubPage = this.tempSubCurrent = 3;
            } else if (name === 'copyrighterHelpCenter') {
              this.currentSubPage = this.tempSubCurrent = 2;
            } else {
              this.currentSubPage = this.tempSubCurrent = -1;
            }
          },
          setTempSubCurrent(temp) {
            this.tempSubCurrent = temp;
          },
          logout() {
            axios.post(`/api/auth/logout`).then( res => {
              if (res) {
                window.location.reload();
              }
            });
          }
        },
        computed: {
          IMG_HOST(){
            return this.$store.state.IMG_HOST;
          },
          isAnchor() {
            return this.$store.state.user.anchor.level > -1
          }
        },
        beforeMount() {
          this.setCurrentPage();
          this.setCurrentSubPage();
        }
    }

</script>
<style lang="sass">
    @import "../../sass/components/top.scss";
</style>



// WEBPACK FOOTER //
// Top.vue?de1e802e